import React, { Component } from "react";
import Nav from "react-bootstrap/Nav";
import { PiCheckCircleFill, PiSparkleBold } from "react-icons/pi";

import campaignTabs from "../../../campaignTabs";

const TAB_STEP_META = {
	campaign_name: {
		eventKey: "first",
		title: "Template Name",
		desc: "Fill template details",
		disabledKey: "campaignTemplateId",
		completed: (p) => !!p.campaignTemplateId,
	},
	attacker_profile: {
		eventKey: "second",
		title: "Attacker Profile",
		desc: "Fill attacker profile information",
		disabledKey: "senderId",
		completed: (p) => !!p.senderId,
	},
	attacker_profile_sms: {
		eventKey: "second-sms",
		title: "Attacker Profile",
		desc: "Fill attacker profile information",
		disabledKey: "senderId",
		completed: (p) => !!p.senderId,
	},
	attacker_profile_telegram: {
		eventKey: "second-telegram",
		title: "Attacker Profile",
		desc: "Fill attacker profile information",
		disabledKey: "senderId",
		completed: (p) => !!p.senderId,
	},
	attacker_profile_call: {
		eventKey: "second-call",
		title: "Attacker Profile",
		desc: "Fill attacker profile information",
		disabledKey: "senderId",
		completed: (p) => !!p.senderId,
	},
	template: {
		eventKey: "third",
		title: "Email Template",
		desc: "Configure email template",
		disabledKey: "templateId",
		completed: (p) => !!p.templateId,
	},
	ai_conversation: {
		eventKey: "third_ai_conversation",
		title: "AI Conversation",
		desc: "Create an AI prompt",
		disabledKey: "aiVishingPromptId",
		completed: (p) => !!(p.aiVishingPromptId || p.aiWhatsappPromptId),
	},
	voice_selection: {
		eventKey: "voice_selection",
		title: "Voice Selection",
		desc: "Choose a voice for attack",
		disabledKey: "vishingVoiceSelectionId",
		completed: (p) => !!p.vishingVoiceSelectionId,
	},
	template_sms: {
		eventKey: "third-sms",
		title: "SMS Template",
		desc: "Configure SMS template",
		disabledKey: "templateId",
		completed: (p) => !!p.templateId,
	},
	template_telegram: {
		eventKey: "third-telegram",
		title: "Message Template",
		desc: "Configure Message template",
		disabledKey: "templateId",
		completed: (p) => !!p.templateId,
	},
	page: {
		eventKey: "fourth",
		title: "Landing Page",
		desc: "Configure landing page",
		disabledKey: "pageId",
		completed: (p) => !!p.pageId,
		// Optional: credential harvesting (hence whether a landing page is used)
		// is a campaign-level setting now, so this step must not block the wizard.
		optional: true,
	},
	ransomware_file: {
		eventKey: "fifth",
		title: "Ransomware File",
		desc: "Configure ransomware file",
		disabledKey: "ransomwareFileCompleted",
		completed: (p) => !!p.ransomwareFileCompleted,
	},
	training: {
		eventKey: "six",
		title: "Training",
		desc: "Select awareness training course",
		disabledKey: "trainingId",
		completed: (p) => !!p.trainingId,
	},
	game: {
		eventKey: "seven",
		title: "Game",
		desc: "Select game",
		disabledKey: "gameId",
		completed: (p) => !!p.gameId,
	},
	awareness_page: {
		eventKey: "eight",
		title: "Awareness Page",
		desc: "Configure the awareness page",
		disabledKey: "awarenessPageId",
		completed: (p) => !!p.awarenessPageId,
	},
	preview: {
		eventKey: "nine",
		title: "Preview",
		desc: "Confirm the filled details",
		disabledKey: "preview",
		completed: () => false,
	},
};

export default class NavTabs extends Component {

	// constructor(props) {
	// 	super(props);
	// }

	render() {
		const simulationType = this.props.simulation_type;
		const attackType = this.props.attack_type;
		const activeTabKey = this.props.activeTabKey;

		const genericTabs = [
			"campaign_name",
			"template",
			"awareness_page",
			"attacker_profile",
			"preview",
		];

		let campaignTemplateTab = [];
		if(this.props.targetInteractionType === "inbound" && (this.props.attack_type === "Vishing" || (this.props.attack_type === "WhatsApp" && this.props.isAIbased))) {
			campaignTemplateTab = campaignTabs?.[this.props.simulation_type]?.[this.props.attack_type]?.inbound || genericTabs;
		} else {
			campaignTemplateTab =
			campaignTabs?.[simulationType]?.[attackType] || genericTabs;
		}

		const visibleSteps = [];
		(campaignTemplateTab || []).forEach((tabName) => {
			// Landing Page is shown per attack vector; credential harvesting is a
			// campaign-level setting now, so the step is no longer hidden here.
			const meta = TAB_STEP_META[tabName];
			if (!meta) {
				return;
			}
			const completed = meta.completed(this.props);
			const isActive = activeTabKey === meta.eventKey;
			visibleSteps.push({
				key: `${tabName}-${meta.eventKey}`,
				eventKey: meta.eventKey,
				title: meta.title,
				desc: meta.desc,
				completed,
				isActive,
				optional: !!meta.optional,
			});
		});

		/* Disable steps until prior wizard steps have data; always leave the current tab enabled so it shows active (e.g. Awareness). */
		visibleSteps.forEach((step, idx) => {
			let priorIncomplete = false;
			for (let j = 0; j < idx; j++) {
				// Optional steps (e.g. Landing Page) don't block later steps.
				if (!visibleSteps[j].completed && !visibleSteps[j].optional) {
					priorIncomplete = true;
					break;
				}
			}
			step.navDisabled = priorIncomplete && !step.isActive;
		});

		return (
			<Nav
				variant="pills"
				className="flex-column m-0 template-wizard-nav"
			>
				{visibleSteps.map((step, idx) => {
					const stepNum = idx + 1;
					const itemClass = [
						"template-wizard-step",
						step.isActive ? "active" : "",
						step.completed ? "completed" : "",
						step.navDisabled ? "disabled" : "",
					]
						.filter(Boolean)
						.join(" ");
					return (
						<Nav.Item key={step.key} className={itemClass}>
							<Nav.Link
								eventKey={step.eventKey}
								disabled={step.navDisabled}
								className={`template-wizard-step-link ${step.isActive ? "active" : ""}`}
							>
								<div className="step-number">
									{step.completed ? (
										<PiCheckCircleFill className="step-completed-icon" />
									) : (
										<span className="step-number-circle">
											{stepNum}
										</span>
									)}
								</div>
								<div className="step-content">
									<div
										className={
											step.eventKey === "voice_selection"
												? "step-title step-title--with-deepfake-badge"
												: "step-title"
										}
									>
										<span className="step-title__text">{step.title}</span>
										{step.eventKey === "voice_selection" ? (
											<span className="nav-wizard-deepfake-badge" role="note">
												<PiSparkleBold
													className="nav-wizard-deepfake-badge__icon"
													aria-hidden
												/>
												Deepfake
											</span>
										) : null}
									</div>
									<div className="step-description">
										{step.completed ? "Completed" : step.desc}
									</div>
								</div>
							</Nav.Link>
						</Nav.Item>
					);
				})}
			</Nav>
		);
	}
}
